import React, { Fragment, useState } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from 'react-router-dom'
import estilos from './ZonasComponent.module.css'
import { agregarLocalidad, editarLocalidad } from '../../../redux/DucksUnidadInspeccion/ZonasDuck'
import { agregarMesZona } from '../../../redux/DucksUnidadInspeccion/MesZonaDuck';
import { useDispatch } from 'react-redux';
import MapaPickerComponent from './MapaPickerComponent';

const LocalidadFormComponent = (props) => {
    const zona = props.zona
    const dispatch = useDispatch()
    const localidadModify = props.localidadModify
    const [defaultLocation, setDefaultLocation] = useState({ lat: 17.0669, lng: -96.7203 });
    const [location, setLocation] = useState(defaultLocation);

    const [inicialStateFormik, setInicialStateFormik] = useState({
        id: '', nombre: '', lat: 0, lng: 0, pin: '', asociados: [], zona: zona.id
    }
    )

    React.useState(() => {
        if (localidadModify !== null) {
            localidadModify
            setInicialStateFormik({
                idlocalidad: localidadModify.idlocalidad,
                nombrelocalidad: localidadModify.nombrelocalidad,
                lat: Number(localidadModify.latitud) + '',
                lng: Number(localidadModify.longitud) + '',
                pin: 'red',
            })

            //SE CARGA LA 
            setLocation({ lat: Number(localidadModify.latitud), lng: Number(localidadModify.longitud) })
        }
        else setLocation(defaultLocation)


    }, [localidadModify])

    return (
        <Fragment>
            <div className='row'>
                <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 ${estilos.contenedorBorder}`}>
                    <div className='row'>
                        <h1 className={`${estilos.tituloForm}`}>{
                            localidadModify ?
                                "Editar Localidades de la zona" :
                                `Añadir Localidad en la Zona ' ${zona.nombrezona}'`
                        }</h1>
                    </div>

                    <MapaPickerComponent ubicacion={location} setLocation={setLocation} />

                    <Formik
                        initialValues={inicialStateFormik}
                        validate={values => {
                            const errors = {};
                            return errors;
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                            if (localidadModify) {
                                const data = {
                                    data: {
                                        idlocalidad: localidadModify.idlocalidad,
                                        //idzona: zona.idzona,
                                        nombrelocalidad: values.nombrelocalidad,
                                        latitud: Number(location.lat) + '',
                                        longitud: Number(location.lng) + '',
                                        //pin: 'red'
                                    }
                                }

                                dispatch(editarLocalidad(data))
                                props.actualizarZonas()
                                //window.location.reload()

                            } else {
                                const data = {
                                    data: {
                                        //idzona: zona.idzona,
                                        nombrelocalidad: values.nombrelocalidad,
                                        latitud: Number(location.lat) + '',
                                        longitud: Number(location.lng) + '',
                                        //pin: 'red'
                                    }
                                }

                                dispatch(agregarLocalidad(data))
                                props.actualizarZonas()
                                //window.location.reload()
                                //props.handleClose()

                            }
                            setSubmitting(false);
                            props.onClose()
                        }}
                    >

                        {({ isSubmitting }) => (
                            <Form>
                                <div className={`container ${estilos.contenedorForm}`}>

                                    <Field type="hidden" name="idzona" className='form-control' value={zona.idzona} />

                                    <label htmlFor="nombrelocalidad">Nombre de la Localidad:</label><br />
                                    <Field type="text" name="nombrelocalidad" className='form-control' />
                                    <ErrorMessage name="nombrelocalidad" component="div" className={`${estilos.error}`} />


                                    <Field type="hidden" name="lat" className='form-control' />
                                    <ErrorMessage name="lat" component="div" className={`${estilos.error}`} />

                                    <Field type="hidden" name="lng" className='form-control' />
                                    <ErrorMessage name="lng" component="div" className={`${estilos.error}`} /><br />

                                    <div className='text-center'>
                                        <button type="submit" disabled={isSubmitting} className='btn btn-lg btn-success'>
                                            {
                                                localidadModify ?
                                                    "Guardar cambios" :
                                                    "Agregar Localidad"
                                            }
                                        </button>
                                    </div>

                                </div>
                            </Form>
                        )}

                    </Formik>

                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(LocalidadFormComponent)